"use strict";

const events = require("../event_helper");
const keyModule = require("../keyboard.js");
const alertModule = require("js/alert");

/**
 * Add event listener to handle clicks on ldc-link-content elements.
 */
module.exports.addClickListener = (element, dispatcher) => {
    console.log("ldcLinkContent.addClickListener()");

    const clickListener = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const openInPartner = event.shiftKey;
        const linkedId = element.dataset.cardid;
        const anchorId = element.dataset.anchorId;
        const isInaccessible = element.dataset.inaccessible;

        if (isInaccessible == "true") {
            alertModule.danger(document, "This card is not accessible.");
            console.log("Link inaccessible, so ignore it.");
        } else {
            console.log("on click", { linkedId, anchorId, openInPartner });
            if (anchorId) {
                events.displayCard(dispatcher, linkedId, {
                    openInPartner: openInPartner,
                    inNewWindow: keyModule.ctrlMeta(event),
                    // Scroll to the target link destination
                    scrollToElementSelector: `ldc-link-destination[id='${anchorId}']`,
                });
            } else {
                console.error("Anchor id is missing");
            }
        }
    };
    element.addEventListener("click", clickListener);
};

/**
 * The LDCLinkContent points to a ldc-link-destination tag.
 * It should have a cardId and anchorId to match the pointing ldc-link-destinations
 */
class LDCLinkContent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {}

    disconnectedCallback() {}
}

window.customElements.define("ldc-link-content", LDCLinkContent);
